/*@ngInject*/
const ImportClassCodesRepository = function (baseRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.importClassCodes = function (file) {
        const url = '/classCodeUpload/ClassCodeUploadServlet',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                params: {},
                headers: {
                    'Content-Type': undefined
                }
            };
        formData.append('file', file);
        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

};
angular.module('ums.configuration')
    .service('importClassCodesRepository', ImportClassCodesRepository);
